import { useState, useCallback } from 'react';
import { Student } from '@/types';

export const useStudentForm = (initialData: Partial<Student>) => {
  const [formData, setFormData] = useState<Partial<Student>>(initialData);
  const [hasChanges, setHasChanges] = useState(false);

  const handleFieldChange = useCallback((id: keyof Student, value: any) => {
    setFormData(prev => ({
      ...prev,
      [id]: value
    }));
    setHasChanges(true);
  }, []);

  const resetForm = useCallback((data: Partial<Student>) => {
    setFormData(data);
    setHasChanges(false);
  }, []);

  return {
    formData,
    hasChanges,
    handleFieldChange,
    resetForm
  };
};